//TODO: Este componente pertenece a los proveedores terrestres del mayorista
import {
    Button,
    Container,
    Grid,
} from "@material-ui/core"
import { useDispatch } from "react-redux"
import { Fragment, useEffect, useState } from "react"
import { obetenerPaqueteMayoristaListaDetalle } from "../../../ducks/proveedorMayoristaDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import TProveedoresTerrestres from "../TProveedoresTerrestres"
import FProveedoresTerrestres from "../FProveedoresTerrestres"
import FCircuitos from "../FCircuito"
import FPAroveedoresTerrestres from "../FAProveedorTerrestre"
import FPaquetesHoteles from "../FHotelPaqueteTerrestre"
import FPaquetePlaza from "../FPlazaPaqueteTerrestre"
import FPaquetesExtras from "../FExtraPaqueteTerrestre"
import FPaquetesDestinos from "../FCiudadesPaqueteExtra"
import FPaquetesGaleria from "../FPaqueteGaleria"
import FConfigurarDescuentos from "../FConfigurarDescuentos"
import FConfigurarMayorista from "../FConfigurarMayorista"
// import HotelSearchForm from "../../Paquetes/FHotelSearchForm/HotelSearchForm"

const useProvedorTerrestre = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        // dispatch(obtenerTerrestreAllAction()).then(Response => {
        //     dispatch(offLoadAction())
        // })
        dispatch(obetenerPaqueteMayoristaListaDetalle()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const VProveedorTerrestre = () => {
    useProvedorTerrestre()
    const [openDescuentos, setOpenDescuentos] = useState(false);
    
    return (
        <Fragment>
            <Container maxWidth="xl" style={{ marginTop: "2rem"}}>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between", marginBottom: "1.25rem" }}>
                    <FProveedoresTerrestres />  

                    <Button 
                        variant="outlined" 
                        color="secondary"
                        onClick={() => setOpenDescuentos(true)}
                    >
                        Configurar Descuentos
                    </Button>
                </Grid>
                
                <Grid item xs={12}>
                    <TProveedoresTerrestres />
                </Grid>
                
                <FCircuitos />
                <FPAroveedoresTerrestres />
                <FPaquetesHoteles />
                <FPaquetePlaza />
                <FPaquetesExtras />
                <FPaquetesDestinos />
                {/* <FPersonalizarPaquete /> */}
                <FConfigurarMayorista />
                <FPaquetesGaleria />
                <FConfigurarDescuentos
                    open={openDescuentos} 
                    onClose={() => setOpenDescuentos(false)} 
                />
            </Container>
        </Fragment>
    )
}
export default VProveedorTerrestre